import { memo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { IconArrowRight, IconType } from '@app/icons';
import { cn } from 'lib/utils';

export interface Navigation {
  title: string;
  path: string;
  icon: IconType;
  children?: Navigation[];
}

interface SidebarProps {
  data: Navigation[];
}

const Sidebar = (props: SidebarProps) => {
  const location = useLocation();
  const { data } = props;

  return (
    <nav className="flex flex-col gap-1">
      {data.map(({ icon: Icon, ...item }, itemIndex) => {
        const isActive = location.pathname === item.path;
        return (
          <NavLink
            to={item.path}
            key={itemIndex.toString()}
            className={cn(
              'flex items-center gap-3 rounded-lg px-4 py-2 transition-colors',
              isActive
                ? 'bg-primary/10 text-primary font-semibold'
                : 'text-muted-foreground hover:bg-accent',
              'group'
            )}
          >
            <Icon
              className={cn(
                'w-5 h-5 flex-shrink-0',
                isActive ? 'text-primary' : 'text-muted-foreground'
              )}
            />
            <span className="text-base">{item.title}</span>
            <span
              className={cn(
                'ml-auto transition-transform',
                isActive ? 'text-primary' : 'text-muted-foreground',
                'group-hover:text-primary'
              )}
            >
              <IconArrowRight className="w-4 h-4" />
            </span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default memo(Sidebar);
